@if (errors().length > 0) {
  <div class="danger white-space-pre-wrap form-control-error">
    @for (error of errors(); track error.key) {
      <p>{{ error.key | translate : error.params }}</p>
    }
  </div>
}
